import { Map } from 'immutable';
import { GET_COUPONS_SUCCESS } from './CouponsActionTypes';

const initialState = Map({
  couponList: [],
});

export default function CouponsReducer(state = initialState, action) {
  switch (action.type) {
    case GET_COUPONS_SUCCESS:
      return Map({
        ...state,
        couponList: action.response,
      });
    default:
      return state;
  }
}
